import {autoResize, getLocalStorageItem} from "../functions"
import {PathLineClass} from "./PathLineClass"
import {Link} from "react-router-dom"
import React, {useState, useRef, useEffect} from "react"

export default function DrivePropertiesCard({folderData, lang}) {
    const [copied, setCopied] = useState(false)
    const properties = getLocalStorageItem('folder-properties-data')
    const [isEditingDesc, setIsEditingDesc] = useState(false)
    const [descValue, setDescValue] = useState(folderData.folder.description || '')
    const [nameValue, setNameValue] = useState(folderData.folder.name)
    const textareaRef = useRef(null)

    const [isEditingName, setIsEditingName] = useState(false)
    const nameInputRef = useRef(null)

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto'
            textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'
        }
        autoResize(textareaRef.current)
        if (properties.name !== nameValue || properties.desc !== descValue) {
            document.querySelector('#btn-save').removeAttribute('disabled')
        }
    }, [descValue, nameValue, properties])

    if (!folderData) return null

    const formatDate = (date) =>
        date ? new Date(date).toLocaleString() : '—'

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(folderData.folder.accessLink)
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        } catch (e) {
            console.error('Copy failed', e)
        }
    }

    return (
        <div>
            <div className={'folder-prop-card'}>

                <PathLineClass
                    documents={getLocalStorageItem('documents')}
                    search={true}
                />

                {folderData.thumb && (
                    <img
                        src={folderData.thumb}
                        alt="thumbnail"
                        className={'folder-prop-card-thumb'}
                        style={{marginTop: '20px'}}
                    />
                )}

                {/* ДАТА */}
                <div className={'folder-prop-card-row'}>
                    <div className={'folder-prop-card-row-inner'}>
                        <span className={'folder-prop-card-label'}>
                            {lang.body.folderPage.createdDate}
                        </span>
                        <span>
                            {formatDate(folderData.folder.dateCreated)}
                        </span>
                    </div>
                </div>

                {/* ВЛАДЕЛЕЦ */}
                <div className={'folder-prop-card-row'}>
                    <div className={'folder-prop-card-row-inner'}>
                        <span className={'folder-prop-card-label'}>
                            {lang.body.folderPage.owner}
                        </span>
                        <span>
                            {folderData.ownerName || '—'}
                        </span>
                    </div>
                </div>

                {/* ИМЯ */}
                <div className={'folder-prop-card-row'}>
                    <div className={'folder-prop-card-row-inner'}>
                        <span className={'folder-prop-card-label'}>
                            {lang.body.folderPage.labelName}
                        </span>

                        <div className={'folder-prop-card-input-container'}>
                            <input id={'name'} className={'folder-prop-card-input-inner'}
                                   ref={nameInputRef}
                                   value={nameValue}
                                   readOnly={!isEditingName}
                                   onChange={(e) => setNameValue(e.target.value)}
                            />

                            <div className={'folder-prop-card-btn'}
                                 onClick={() => {
                                     if (!isEditingName) {
                                         setIsEditingName(true)
                                         setTimeout(() => nameInputRef.current?.focus(), 0)
                                     } else {
                                         folderData.saveFolderHandler().then()
                                         setIsEditingName(false)
                                     }
                                 }}>
                                <i className={isEditingName ? "fa-solid fa-check" : "fa-solid fa-pen"}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ОПИСАНИЕ */}
                <div className={'folder-prop-card-row'}>
                    <div className={'folder-prop-card-row-inner'}>
                        <span className={'folder-prop-card-label'}>
                            {lang.body.folderPage.labelDescription}
                        </span>

                        <div className={'folder-prop-card-input-container'}>
                            <textarea
                                id={'description'}
                                ref={textareaRef}
                                value={descValue}
                                readOnly={!isEditingDesc}
                                rows={1}
                                onChange={(e) => {
                                    setDescValue(e.target.value)
                                    autoResize(textareaRef.current)
                                }}
                                onInput={() => autoResize(textareaRef.current)}
                                className={'folder-prop-card-input-inner'}
                                style={{
                                    resize: 'none',
                                    overflow: 'hidden',
                                    height: '32px',
                                    lineHeight: '16px'
                                }}
                            />

                            <div className={'folder-prop-card-btn'}
                                 onClick={() => {
                                     if (!isEditingDesc) {
                                         setIsEditingDesc(true)
                                         setTimeout(() => {
                                             autoResize(textareaRef.current)
                                             textareaRef.current?.focus()
                                         }, 0)
                                     } else {
                                         folderData.saveFolderHandler().then()
                                         setIsEditingDesc(false)
                                     }
                                 }}>
                                <i className={isEditingDesc ? "fa-solid fa-check" : "fa-solid fa-pen"}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ССЫЛКА */}
                <div className={'folder-prop-card-row'}>
                    <div className={'folder-prop-card-row-inner'}>
                        <span className={'folder-prop-card-label'}>
                            {lang.body.folderPage.accessLink}
                        </span>

                        {folderData.folder.accessLink ? (
                            <div className={'folder-prop-card-shared-link'}>
                                <span className={'folder-prop-card-shared-link-text'} onClick={handleCopy}>
                                    {folderData.folder.accessLink}
                                </span>
                                <div className={'folder-prop-card-btn'} onClick={folderData.shareHandler}>
                                    <i className="fa-solid fa-xmark"/>
                                </div>
                            </div>
                        ) : (
                            <Link onClick={folderData.shareHandler}>
                                {lang.body.contextMenu.share}
                            </Link>
                        )}
                    </div>
                </div>

                {/* ОТКРЫТЬ */}
                <a href={`/${lang.lang}/folder/open/${folderData.folder._id}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{display: 'block', marginTop: 12}}>
                    {lang.body.folderPage.openInNewTab}
                </a>
            </div>

            {copied && (
                <div className={'folder-prop-card-shared-link-toast'}>
                    {lang.body.folderPage.linkCopied}
                </div>
            )}
        </div>
    )
}